import { Box, Button, Flex, Heading, Text } from "@chakra-ui/react";
import { FC, ReactElement, useState } from "react";
import { FaCreditCard } from "react-icons/fa";
import ListPayment from "components/payment-list";

interface CheckoutPaymentMethodStepProps {
    handleSubmit: any;
    selectedPaymentMethod: string;
    setSelectedPaymentMethod: any;
};

const CheckoutPaymentMethodStep: FC<CheckoutPaymentMethodStepProps> = ({ handleSubmit, selectedPaymentMethod, setSelectedPaymentMethod }): ReactElement => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const handleFormSubmit = () => {
        setIsSubmitting(true);
        handleSubmit().then(() => {
            setIsSubmitting(false);
        });
    };

    return (
        <Box mt={{ base: 2, md: 6 }} mb={{ base: 2, md: 6 }} p={{ base: 2, md: 6 }} borderRadius={8} borderStyle={"solid"} borderWidth={{ base: 0, md: 1 }} borderColor={"blackAlpha.300"} textAlign={"center"} >
            <Heading fontSize="lg">Pembayaran</Heading>
            <Text fontSize={"xs"}>Pilihlah cara pembayaran yang sesuai dengan preferensi Anda untuk melanjutkan transaksi ini.</Text>

            <Box pt={8} pb={4}>
                <Heading fontSize={'sm'} textAlign={"left"} mb={4}>Pilih Metode Pembayaran:</Heading>
                <ListPayment defaultPaymentMethod={selectedPaymentMethod} onChangeCallback={setSelectedPaymentMethod} />
            </Box>

            <Flex width="100%" justify="center" mb={6}>
                <Button onClick={handleFormSubmit} size={"lg"} leftIcon={<FaCreditCard />} isLoading={isSubmitting}>
                    Selesaikan Pembayaran
                </Button>
            </Flex>
        </Box>
    );
};

export default CheckoutPaymentMethodStep;